import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { languageAtom } from '@root/shared/localization/atoms'

import { PinterestEmbed } from './pinterest-pin-embed'

import type * as KnownSocialPlatformResource from '../model/known-social-platform-resource'

export const SocialPinterestEmbed = ({
  resource,
  onLoad,
}: {
  resource: KnownSocialPlatformResource.PinterestKnownSocialPlatformResource
  onLoad?: () => void
}) => {
  const [currentLang] = useAtom(languageAtom)

  return (
    <Root>
      <PinterestEmbed
        columns={2}
        size="large"
        embedUrl={resource.embedUrl}
        resourceType={resource.type}
        lang={currentLang}
        onLoad={onLoad}
      />
    </Root>
  )
}

const Root = styled.div`
  position: relative;
  width: 350px;
  min-height: 300px;
  max-height: var(--viewport-height);

  overflow: auto;
`
